import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function OrganicSensorsUseCase() {
  return (
    <>
    <section
      id="organic-sensors"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">
        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Organic Sensors
          </h1>
          <p className="text-slate-300 space-y-2">
            Organic sensors use semiconducting or responsive organic materials to detect stimuli such as gases, 
            pressure, humidity, temperature, or light. These devices offer mechanical flexibility, low-cost fabrication, 
            and the potential for disposable or wearable formats — opening up new frontiers in healthcare, 
            environmental monitoring, smart packaging, and predictive maintenance. 
            The ability to conform to irregular surfaces and operate in low-power settings makes organic sensors 
            ideal for embedding into hard-to-access industrial equipment or wearable systems for real-time diagnostics. 
  
          </p>
        </div>

        {/* How Apoello Helps */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>
              Identify molecules with strong, specific responses to light, heat, or redox triggers for sensing applications.
            </li>
            <li>
              Filter by absorption energy, charge reorganisation, oscillator strength, and HOMO–LUMO alignment.
            </li>
            <li>
              Assess charge localisation and vibrational modes to optimise signal strength and response speed.
            </li>
            <li>
              Procure promising sensors or modular fragments for experimental validation.
            </li>
          </ul>
        </div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Many organic sensors are discovered by chance or trial-and-error, making it difficult to scale or design for new analytes.
            DiaDEM™ helps de-risk development by simulating how materials interact with targets — speeding up prototyping and 
            increasing the likelihood of functional, high-performance sensors.
          </p>
        </div>


        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>
      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
